(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ib-buy-now"] && !Shopify.designMode) return;
  try {
    (function () {
    const btn = document.querySelector('[data-ib-buy-now]');
    if (!btn) return;
    btn.addEventListener('click', async function () {
      if (btn.dataset.loading === '1') return;
      btn.dataset.loading = '1';
      btn.disabled = true;
      const original = btn.textContent;
      btn.textContent = btn.dataset.processing;

      try {
        const form = document.querySelector(
          'product-form-component form, form[action*="/cart/add"]'
        );
        if (!form) throw new Error('form not found');
        const data = new FormData(form);
        const resp = await fetch(btn.dataset.cartAddUrl, {
          method: 'POST',
          body: data,
          headers: { 'Accept': 'application/json' }
        });
        if (!resp.ok) throw new Error('cart add failed: ' + resp.status);
        window.location.href = btn.dataset.checkoutUrl;
      } catch (e) {
        console.error('[ib-buy-now]', e);
        btn.textContent = original;
        btn.disabled = false;
        btn.dataset.loading = '0';
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ib-card-wishlist-overlay"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ibCardHeartInit) return;
    window.__ibCardHeartInit = true;

    const HEART_SVG =
      '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M12 20.5 C 8 17 3 13 3 8.5 A 4.5 4.5 0 0 1 12 7 A 4.5 4.5 0 0 1 21 8.5 C 21 13 16 17 12 20.5 Z"/>' +
      '</svg>';

    function extractHandle(href) {
      if (!href) return null;
      const m = href.match(/\/products\/([^/?#]+)/);
      return m ? m[1] : null;
    }

    function injectHearts(root) {
      const cards = (root || document).querySelectorAll(
        '.product-card:not([data-ib-heart-injected]), .resource-card:not([data-ib-heart-injected])'
      );
      cards.forEach(function (card) {
        if (card.dataset.ibHeartInjected === '1') return;
        const link = card.querySelector('a[href*="/products/"]');
        const handle = extractHandle(link && link.getAttribute('href'));
        if (!handle) return;

        const gallery = card.querySelector('.card-gallery, .product-card__gallery, .resource-card__image, .product-card__media') || card;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ib-card-heart';
        btn.dataset.ibWishlist = '';
        btn.dataset.productHandle = handle;
        btn.setAttribute('aria-label', document.querySelector('[data-ib-card-wishlist-label]').dataset.ibCardWishlistLabel);
        btn.setAttribute('aria-pressed', 'false');
        btn.innerHTML = HEART_SVG;
        gallery.appendChild(btn);
        card.dataset.ibHeartInjected = '1';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { injectHearts(); });
    } else {
      injectHearts();
    }

    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) injectHearts(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ib-color-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    const wrap = document.querySelector('[data-ib-color-sel]');
    if (!wrap) return;
    const nameEl = wrap.querySelector('[data-ib-color-name]');
    const dots = wrap.querySelectorAll('[data-ib-color-dot]');

    function findHorizonInput(value) {
      const inputs = document.querySelectorAll(
        '.variant-picker input[type="radio"], variant-picker-component input[type="radio"]'
      );
      for (const inp of inputs) {
        if (inp.value === value) return inp;
      }
      return null;
    }

    function hideHorizonColorOption() {
      const legends = document.querySelectorAll('.variant-picker legend, .variant-picker .variant-option__label');
      legends.forEach(function (lg) {
        const t = (lg.textContent || '').trim().toLowerCase();
        if (t === 'culoare' || t === 'color' || t === 'colour' || t === 'culori' || t.startsWith('culoare') || t.startsWith('color')) {
          const fieldset = lg.closest('fieldset, .variant-option, .variant-option--swatches');
          if (fieldset) fieldset.style.display = 'none';
        }
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const value = dot.dataset.value;
        dots.forEach(function (d) {
          d.classList.remove('is-active');
          d.setAttribute('aria-checked', 'false');
        });
        dot.classList.add('is-active');
        dot.setAttribute('aria-checked', 'true');
        if (nameEl) nameEl.textContent = value;

        const horizonInput = findHorizonInput(value);
        if (horizonInput) {
          horizonInput.click();
          horizonInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    hideHorizonColorOption();
    new MutationObserver(hideHorizonColorOption).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ib-klaviyo-newsletter-hook"] && !Shopify.designMode) return;
  try {
    (function () {
    // TODO: conectează Klaviyo API key here — replace with real Klaviyo company_id + list_id
    // Once values are filled, the hook auto-fires on newsletter submit.
    window.IB_KLAVIYO_COMPANY_ID = window.IB_KLAVIYO_COMPANY_ID || '';
    window.IB_KLAVIYO_LIST_ID = window.IB_KLAVIYO_LIST_ID || '';

    function findNewsletterForms() {
      return document.querySelectorAll(
        'form[action*="/contact#newsletter"], ' +
        'form[action*="newsletter"], ' +
        'form[id*="newsletter"], ' +
        'email-signup-component form'
      );
    }

    function subscribeToKlaviyo(email) {
      if (!window.IB_KLAVIYO_COMPANY_ID || !window.IB_KLAVIYO_LIST_ID) return;
      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'IB footer newsletter',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            list: { data: { type: 'list', id: window.IB_KLAVIYO_LIST_ID } }
          }
        }
      };
      fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + window.IB_KLAVIYO_COMPANY_ID,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-10-15'
          },
          body: JSON.stringify(payload),
          mode: 'cors',
          keepalive: true
        }
      ).catch(function () { /* silent — Shopify native form continues regardless */ });
    }

    function bindForm(form) {
      if (form.dataset.ibKlaviyoBound === '1') return;
      form.dataset.ibKlaviyoBound = '1';
      form.addEventListener('submit', function () {
        const input = form.querySelector('input[type="email"], input[name*="email"]');
        const email = input && input.value && input.value.trim();
        if (email && /.+@.+\..+/.test(email)) {
          subscribeToKlaviyo(email);
        }
      });
    }

    function init() {
      findNewsletterForms().forEach(bindForm);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
